var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Button } from '@ui/atoms/Button';
import { showSuccessToast, showErrorToast } from '@ui';
import { translate } from '@utils/i18n';
import { NAMESPACE, STRATEGY } from './constants';
import { useConflictResolution } from './hooks/useConflictResolution';
import { acceptByTechnician, keepMoreComplete } from './services/conflictResolutionService';
import AcceptByTechnicianModal from './components/AcceptByTechnicianModal';
import KeepMoreCompleteModal from './components/KeepMoreCompleteModal';
export default function ConflictsListing({ inspectionId, permissions }) {
    const [openStrategy, setOpenStrategy] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { summary, isLoading, hasError } = useConflictResolution(inspectionId, openStrategy !== null);
    if (!permissions.resolve)
        return null;
    const handleClose = () => {
        if (!isSubmitting)
            setOpenStrategy(null);
    };
    const startRun = (request, startedKey) => __awaiter(this, void 0, void 0, function* () {
        setIsSubmitting(true);
        try {
            yield request();
            setOpenStrategy(null);
            showSuccessToast(translate(startedKey, { namespace: NAMESPACE }));
        }
        catch (_a) {
            showErrorToast(translate('failed', { namespace: NAMESPACE }));
        }
        finally {
            setIsSubmitting(false);
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "default", type: "button", onClick: () => setOpenStrategy(STRATEGY.ACCEPT_FROM_TECHNICIAN) },
            React.createElement("i", { className: "fa-light fa-user-check" }),
            translate('accept_by_technician', { namespace: NAMESPACE })),
        React.createElement(Button, { variant: "default", type: "button", onClick: () => setOpenStrategy(STRATEGY.KEEP_MOST_COMPLETE) },
            React.createElement("i", { className: "fa-light fa-list-check" }),
            translate('keep_more_complete', { namespace: NAMESPACE })),
        React.createElement(AcceptByTechnicianModal, { isOpen: openStrategy === STRATEGY.ACCEPT_FROM_TECHNICIAN, isSubmitting: isSubmitting, isLoading: isLoading, hasError: hasError, summary: summary, onClose: handleClose, onConfirm: (technicianId) => startRun(() => acceptByTechnician(inspectionId, technicianId), 'started') }),
        React.createElement(KeepMoreCompleteModal, { isOpen: openStrategy === STRATEGY.KEEP_MOST_COMPLETE, isSubmitting: isSubmitting, isLoading: isLoading, hasError: hasError, summary: summary, onClose: handleClose, onConfirm: () => startRun(() => keepMoreComplete(inspectionId), 'keep_more_complete_started') })));
}
